import { api } from './BaseService'

export const getFabrics = async () => {
    return await api.get(`/fabrics`)
}

export const getFabricById = async (id) => {
    return await api.get(`/fabrics/${id}`)
}

export const createFabric = async (data) => {
    return await api.post(`/fabrics`, data)
}
export const updateFabric = async (data) => {
    return await api.put(`/fabrics/${data?.id}`, data)
}
export const deleteFabric = async (id) => {
    return await api.delete(`/fabrics/${id}`)
}
